/**
 * 文件编辑器状态管理
 */

import { create } from 'zustand';

export interface OpenFile {
  path: string;
  content: string;
  originalContent: string;
  size: number;
  language: string;
}

interface FileEditorState {
  openFile: OpenFile | null;
  editorOpen: boolean;
  isSaving: boolean;
  saveError: string | null;

  openFileInEditor: (file: { path: string; content: string; size: number }) => void;
  closeEditor: () => void;
  updateContent: (newContent: string) => void;
  setSaving: (saving: boolean) => void;
  setSaveError: (err: string | null) => void;
}

export const useFileEditorStore = create<FileEditorState>((set) => ({
  openFile: null,
  editorOpen: false,
  isSaving: false,
  saveError: null,

  openFileInEditor: (file) => {
    const language = detectLanguage(file.path);
    set({
      openFile: {
        path: file.path,
        content: file.content,
        originalContent: file.content,
        size: file.size,
        language,
      },
      editorOpen: true,
      saveError: null,
    });
  },

  closeEditor: () => {
    set({
      openFile: null,
      editorOpen: false,
      saveError: null,
    });
  },

  updateContent: (newContent) => {
    set((state) => ({
      openFile: state.openFile
        ? { ...state.openFile, content: newContent }
        : null,
    }));
  },

  setSaving: (saving) => set({ isSaving: saving }),
  setSaveError: (err) => set({ saveError: err }),
}));

/**
 * 根据文件扩展名检测语言
 */
function detectLanguage(filePath: string): string {
  const ext = filePath.split('.').pop()?.toLowerCase() || '';
  const map: Record<string, string> = {
    js: 'javascript',
    jsx: 'javascript',
    mjs: 'javascript',
    ts: 'typescript',
    tsx: 'typescript',
    json: 'json',
    php: 'php',
    html: 'html',
    htm: 'html',
    css: 'css',
    scss: 'css',
    less: 'css',
    py: 'python',
    sql: 'sql',
    md: 'markdown',
    yaml: 'yaml',
    yml: 'yaml',
    xml: 'xml',
    svg: 'xml',
    sh: 'shell',
    bash: 'shell',
    zsh: 'shell',
    conf: 'shell',
    cfg: 'shell',
    ini: 'ini',
    toml: 'toml',
    env: 'shell',
    nginx: 'nginx',
    log: 'text',
    txt: 'text',
  };
  return map[ext] || 'text';
}
